import useSWR from "swr";
import { Utils } from "../common/utils";
import { Committee } from "Stores/commonStore";
const clientConfigs = Utils.getEAIClientConfigs();

interface GetCommitteesResponse {
    data: Committee[];
}


export function useGetCommittees() {
    const { data, error, isLoading } = useSWR<GetCommitteesResponse, Error>(`${clientConfigs.endpoint}/committees/schools/${clientConfigs.school}`);

    return {
        data,
        error,
        isLoading
    };
}
